module.exports = __webpack_public_path__ + "img/coockies.0b8ad8ca.svg";